import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "col-lg-8 fv-row" }
const _hoisted_14 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_28 = { class: "pb-5" }
const _hoisted_29 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "col-form-label fw-normal fs-6" }

import comarcas from "@/core/data/comarcas";
import tratamientos from "@/core/data/tratamientos";
import { FamiliaListado } from "@/store/models";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  familia: {
    type: Object as () => FamiliaListado,
    required: true,
  },
},
  setup(__props) {

const props = __props



const familiaData = computed(() => props.familia);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.servicioDetalle.datosFamilia")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(tratamientos).find((t) => t.id == _unref(familiaData).tratamiento)?.text), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(familiaData).nombre + " " + _unref(familiaData).apellidos), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("formularios.familiaDetalle.dni.label")), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(familiaData).dni), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("formularios.familiaDetalle.email.label")), 1),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(familiaData).email), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("formularios.familiaDetalle.telefono.label")), 1),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(familiaData).telefono), 1)
          ])
        ]),
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccionGroup")), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(familiaData).direccion), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("formularios.familiaDetalle.localidad.label")), 1),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("label", _hoisted_37, _toDisplayString(_unref(familiaData).localidad), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("formularios.servicioDetalle.comarca.label")), 1),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(comarcas).find((c) => c.id == _unref(familiaData).comarcaId)?.text), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("formularios.familiaDetalle.provincia.label")), 1),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(familiaData).provincia), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})